var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_64_11611)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 11.34V7.33334C10.6667 6.96667 10.3667 6.66667 10 6.66667C9.63335 6.66667 9.33335 6.96667 9.33335 7.33334V11.34H8.14002C7.84002 11.34 7.69335 11.7 7.90669 11.9067L9.76669 13.76C9.90002 13.8867 10.1067 13.8867 10.24 13.76L12.1 11.9067C12.3134 11.7 12.16 11.34 11.8667 11.34H10.6667ZM5.76669 2.23334L3.90669 4.09334C3.69335 4.3 3.84002 4.66 4.14002 4.66H5.33335V8.66667C5.33335 9.03334 5.63335 9.33334 6.00002 9.33334C6.36669 9.33334 6.66669 9.03334 6.66669 8.66667V4.66H7.86002C8.16002 4.66 8.30669 4.3 8.09335 4.09334L6.23335 2.23334C6.10669 2.10667 5.89335 2.10667 5.76669 2.23334Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_64_11611"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapIcon);
export default __webpack_public_path__ + "static/media/swap-icon.93a8f844894de1ef80c0847c3bb20abd.svg";
export { ForwardRef as ReactComponent };